module.exports = __webpack_public_path__ + "static/media/step-icon-left-2.603805de.svg";